module.exports = __webpack_public_path__ + "img/Eventos_darme_de_baja.aa3feefa.svg";